module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/4c00e16f50d21811e7025c4d9fe70f31.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Silver/Silver4.svg
// module id = BhLC
// module chunks = 1